module.exports = __webpack_public_path__ + "media/30.1ac9afda.wav";